const queue = [];

function inQueue(target, priority, executeCallback) {
    const queueData = {
        target: target,
        priority: priority,
        callback: executeCallback,
    }

    queue.push(queueData);
    queue.sort((a, b) => a.priority - b.priority);
}

function outQueue() {
    return queue.shift();
}

function getQueueClone() {
    return queue.slice();
}

function getQueueCount() {
    return queue.length;
}

export {inQueue, outQueue, getQueueClone, getQueueCount}